import { ROUTES } from '@/_navigation';

export const coursesTabs = [
  { ...ROUTES.UNREGISTERED, offset: -228 },
  { ...ROUTES.IN_PROGRESS, offset: -127 },
  { ...ROUTES.COMPLETE, offset: -127 },
];

export type CourseTabType = (typeof coursesTabs)[number];
